const listRouter = {
  path: "/list/:id",
  name: "list",
  meta: { auth: true },
  component: () => import("@/views/List.vue")
};

export default listRouter;
